import clsx from 'clsx';

import type { Adaptive } from '../types/Adaptive';

export function composeGapSizeClasses(gap: Adaptive<number>): string {
    if (typeof gap === 'object') {
        return clsx(
            gap.base && `gap-${gap.base}`,
            gap.sm && `sm:gap-${gap.sm}`,
            gap.md && `md:gap-${gap.md}`,
            gap.lg && `lg:gap-${gap.lg}`,
            gap.xl && `xl:gap-${gap.xl}`,
            gap['2xl'] && `2xl:gap${gap['2xl']}`
        );
    }

    return `gap-${gap}`;
}
